import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SelectOption } from '../../../types/purchases/CreditNoteLookup'; // Reutilizado

interface DebitNoteLookupState {
  filteredDocuments: SelectOption[];   // Lista de CCF elegibles para ND
  productOptions: SelectOption[];      // Productos disponibles en el CCF seleccionado
}

const initialState: DebitNoteLookupState = {
  filteredDocuments: [],
  productOptions: [],
};

const debitNoteLookupSlice = createSlice({
  name: 'debitNoteLookup',
  initialState,
  reducers: {
    setDebitFilteredDocuments(state, action: PayloadAction<SelectOption[]>) {
      state.filteredDocuments = action.payload;
    },
    clearDebitFilteredDocuments(state) {
      state.filteredDocuments = [];
    },
    setDebitProductOptions(state, action: PayloadAction<SelectOption[]>) {
      state.productOptions = action.payload;
    },
    clearDebitProductOptions(state) {
      state.productOptions = [];
    },
  },
});

export const {
  setDebitFilteredDocuments,
  clearDebitFilteredDocuments,
  setDebitProductOptions,
  clearDebitProductOptions,
} = debitNoteLookupSlice.actions;

export default debitNoteLookupSlice.reducer;
